import React, { useState } from "react";
import "../../faq.scss";
import FlowTransition from "components/FlowTransition/FlowTransition";
import { FlowTrasitionParamsType } from "components/FlowTransition/types";
import MobileFirstPage from "../MobileFirstPage/MobileFirstPage";
import { FaqContainerType } from "./types";
import FaqTab from "pages/Home/components/Faq/components/FaqTab/FaqTab";
import OperateTab from "../OperateTab/OperateTab";
import RoadSafetyTab from "../RoadSafetyTab/RoadSafetyTab";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { CountryCodeType } from "utils/constants";

const PAGES = {
  Initial: "Initial",
  Account: "Account",
  Slots: "Slots",
  Trips: "Trips",
  Operate: "Operate",
  Earnings: "Earnings",
  RoadSafety: "RoadSafety",
} as const;

const Faq = ({
  initialQuestion,
  initialSection,
  initialSubSection,
}: FaqContainerType) => {
  const { i18n } = useTranslation();
  const { pathname } = useLocation();
  const [, country] = pathname?.split("/") as [
    undefined,
    CountryCodeType,
    string
  ];
  const i18nLanguage = i18n.language || "es_AR";
  const countryFromLanguage =
    i18nLanguage.split("_")[1]?.toUpperCase() || "AR";
  const countryUpperCase = (country?.toUpperCase() ||
    countryFromLanguage) as CountryCodeType;
  const showRoadSafetyFaq = countryUpperCase === "AR";

  const PagesOrder = [
    PAGES.Account,
    PAGES.Slots,
    PAGES.Trips,
    PAGES.Operate,
    PAGES.Earnings,
    ...(showRoadSafetyFaq ? [PAGES.RoadSafety] : []),
  ];
  const operateSectionIndex = PagesOrder.indexOf(PAGES.Operate);
  const roadSafetySectionIndex = PagesOrder.indexOf(PAGES.RoadSafety);
  const [firstRender, setFirstRender] = useState(true);
  return (
    <FlowTransition
      pages={{
        [PAGES.Initial]: (props: FlowTrasitionParamsType) => (
          <MobileFirstPage
            {...props}
            slots={PAGES.Slots}
            account={PAGES.Account}
            trips={PAGES.Trips}
            earnings={PAGES.Earnings}
            operate={PAGES.Operate}
            roadSafety={showRoadSafetyFaq ? PAGES.RoadSafety : undefined}
          />
        ),
        [PAGES.Account]: (props: FlowTrasitionParamsType) => (
          <FaqTab
            {...props}
            tab="Account"
            backPage={PAGES.Initial}
            initialQuestion={firstRender ? initialQuestion : undefined}
            setFirstRender={() => setFirstRender(false)}
          />
        ),
        [PAGES.Slots]: (props: FlowTrasitionParamsType) => (
          <FaqTab
            {...props}
            tab="Slots"
            backPage={PAGES.Initial}
            initialQuestion={firstRender ? initialQuestion : undefined}
            setFirstRender={() => setFirstRender(false)}
          />
        ),
        [PAGES.Trips]: (props: FlowTrasitionParamsType) => (
          <FaqTab
            {...props}
            tab="Trips"
            backPage={PAGES.Initial}
            initialQuestion={firstRender ? initialQuestion : undefined}
            setFirstRender={() => setFirstRender(false)}
          />
        ),
        [PAGES.Operate]: (props: FlowTrasitionParamsType) => (
          <OperateTab
            {...props}
            backPage={PAGES.Initial}
            initialSubSection={
              initialSection === operateSectionIndex
                ? initialSubSection
                : undefined
            }
            initialQuestion={initialQuestion}
            setFirstRender={() => setFirstRender(false)}
            firstRender={firstRender}
          />
        ),
        [PAGES.Earnings]: (props: FlowTrasitionParamsType) => (
          <FaqTab
            {...props}
            tab="Earnings"
            backPage={PAGES.Initial}
            initialQuestion={firstRender ? initialQuestion : undefined}
            setFirstRender={() => setFirstRender(false)}
          />
        ),
        ...(showRoadSafetyFaq
          ? {
              [PAGES.RoadSafety]: (props: FlowTrasitionParamsType) => (
                <RoadSafetyTab
                  {...props}
                  backPage={PAGES.Initial}
                  initialSubSection={
                    initialSection === roadSafetySectionIndex
                      ? initialSubSection
                      : undefined
                  }
                  initialQuestion={initialQuestion}
                  setFirstRender={() => setFirstRender(false)}
                  firstRender={firstRender}
                />
              ),
            }
          : {}),
      }}
      firstPage={
        initialSection !== undefined
          ? PagesOrder[initialSection] ?? PAGES.Initial
          : PAGES.Initial
      }
      indexPage={PAGES.Initial}
      isOpen={false}
    />
  );
};
export default Faq;
